import {Component, OnInit} from '@angular/core';
import {DictAlias} from './dict-alias.model';
import {FormControl, FormGroup} from '@angular/forms';
import {CustomValidators} from '@core/validator/custom-validators';
import {DictEnum} from '../enums/dict.enum';
import {DictModel} from '../dictionary/dict.model';
import {DictAliasService} from '@core/ecv-http-services/services/dict-alias.service';
import {DialogService} from '../dialog/dialog.service';
import {DictType} from '../enums/dict-types.enum';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';


@Component({
  selector: 'app-dict-panel',
  templateUrl: './dict-panel.component.html'
})

export class DictPanelComponent implements OnInit {
  dictAliases: DictAlias[];
  parentSkillSearchForm: FormGroup;
  DictEnum = DictEnum;
  DictType = DictType;
  currentSkill: DictModel;

  constructor(private dictAliasService: DictAliasService,
              private dialogService: DialogService,
              private spinnerService: Ng4LoadingSpinnerService) {
  }

  ngOnInit() {
    this.createForm();
  }

  removeSkill(model: DictAlias) {
    this.dictAliasService.deleteAlias(model).subscribe(response => {
      const i = this.dictAliases.findIndex(p => p === model);
      if (i >= 0) {
        this.dictAliases.splice(i, 1);
      }
    });
  }

  currentSkillChanged(event) {
    this.currentSkill = event;
    this.dictAliases = undefined;
    this.loadAliases();
  }

  getCurrentSkillId() {
    return this.currentSkill ? this.currentSkill.id : undefined;
  }

  loadAliases() {
    if (this.currentSkill && this.currentSkill.id) {
      this.spinnerService.show();
      this.dictAliasService.getAliases(this.currentSkill.id).subscribe(
        response => {
          this.dictAliases = response;
          this.spinnerService.hide();
        },
        error => {
          this.spinnerService.hide();
        }
      );
    }
  }

  addAliasToList(element: DictAlias) {
    this.dictAliases.unshift(element);
  }

  openModal() {
    this.dialogService.openDictAliasModal(this);
  }

  private createForm() {
    this.parentSkillSearchForm = new FormGroup({
      'skill-search': new FormControl(''),
      'skill-search-id': new FormControl(null, CustomValidators.validateDictExists)
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/dict-panel/dict-panel.component.ts